/*
 * fonctions spécifiques au formulaire de tma
 */
if( $('#frm_tma').get().length ) {

	//
	// champ lot dynamique selon le champ programme
	$('#frm_tma_programme').on('changed.bs.select', function() {
		var options_str = '';
		var $this = $(this);
		var options = $('option:selected', $this).data('options');
		if( options.length ) {
			for( var i = 0; i < options.length; i++ )
				options_str += '<option value="' + options[i].id + '" data-client-link="' + options[i].client_link + '">' + options[i].label + '</option>';
			$('#cont_frm_tma_lot').removeClass('d-none');
			$('#cont_frm_tma_lot_message').addClass('d-none');
		}
		else {
			$('#cont_frm_tma_lot').addClass('d-none');
			$('#cont_frm_tma_lot_message').removeClass('d-none');
		}
		$('#frm_tma_lot').html(options_str).selectpicker('refresh');
		$('#cont_frm_tma_client').html('');
	});

	// affichage client selon lot sélectionné
	$('#frm_tma_lot').on('changed.bs.select', function() {
		console.log($('#frm_tma_lot').val());
		if( $('#frm_tma_lot').val() != '' ) {
			$('#cont_frm_tma_client').html( $('#frm_tma_lot option:selected').data('client-link') );
			$('#cont_frm_tma_client').removeClass('d-none');
		}
		else
			$('#cont_frm_tma_client').addClass('d-none');
	});



}